import { Component, Input, inject } from '@angular/core';
import { MenuItem } from '../../../models/layout.model';
import { Router } from '@angular/router';
import { LayoutService } from 'src/app/core/services/layout.service';
import { AppRoutes } from 'src/app/core/models/routes.model';

@Component({
  selector: 'ui-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
  standalone: false,
})
export class MenuItemComponent {
  private readonly router = inject(Router);
  private readonly layoutService = inject(LayoutService);

  @Input() item!: MenuItem;
  @Input() labelClass = '';

  onItemClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();

    this.layoutService.onMaskClick();
    this.router.navigateByUrl(this.getTargetUrl());
  }

  isActive(): boolean {
    const target = this.getTargetUrl();
    return this.router.url === target || this.router.url.startsWith(`${target}/`);
  }

  private getTargetUrl(): string {
    if (!this.item?.url) return '/';
    if (this.item.url.startsWith('/')) return this.item.url;
    return `/${AppRoutes.MAIN_ROUTE}/${this.item.url}`;
  }
}
